import API, { baseURL } from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/historico-de-sindicato';

/**
 * GET Historicos De Sindicato
 * @returns {Promise<object[]>}
 */
export const getHistoricosDeSindicato = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Historicos De Sindicato (vista optimizada, SQL con JOINs, campos planos)
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getHistoricosDeSindicatoVistaOptimizada = async (params) => {
  try {
    const response = await API.get(`${baseURI}-vista-optimizada`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Historico De Sindicato
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getHistoricoDeSindicato = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Historico De Sindicato
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHistoricoDeSindicato = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Historico De Sindicato
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchHistoricoDeSindicato = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Historico De Sindicato
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteHistoricoDeSindicato = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Plantilla Excel Historico De Sindicato
 * @returns {Promise<boolean>}
 */
export const descargarPlantillaHistoricoDeSindicato = async () => {
  try {
    const response = await API.get(`${baseURI}/plantilla/`, {
      responseType: 'arraybuffer',
    });
    if (response?.data) {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'plantilla_historico_de_sindicato.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Importar Historico De Sindicato (Excel)
 * @param {File} archivo
 * @returns {Promise<object>}
 */
export const importarHistoricoDeSindicato = async (archivo) => {
  const formData = new FormData();
  formData.append('archivo', archivo);
  const response = await API.post(
    `${baseURL}catalogos/historico-de-sindicato-importar-excel/`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response;
};
